var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12 control-section"},[_c('div',{staticClass:"tree-control-wrapper"},[_c('ejs-treeview',{ref:"neTreeForDataSearch",attrs:{"id":"neTreeForDataSearch","allowSelection":false,"fields":_vm.fieldsForDataSearch,"nodeChecked":_vm.nodeCheckedOfNeTreeForDataSearch,"showCheckBox":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }